import { render, staticRenderFns } from "./VisitsTable.vue?vue&type=template&id=369fdd20&scoped=true"
import script from "./VisitsTable.vue?vue&type=script&lang=js"
export * from "./VisitsTable.vue?vue&type=script&lang=js"
import style0 from "./VisitsTable.vue?vue&type=style&index=0&id=369fdd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369fdd20",
  null
  
)

export default component.exports